import React from "react";
import ReactLoading from "react-loading";
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import GenericSwitch from "../../../../../components/GenericSwitch";
import Select from "../../../../../components/Select";
import CalendarGrid from "./Schedule/CalendarGrid";
import TimeRangeCard from "./Schedule/TimeRangeCard";
import helper from "../../../../../utils/helper";
import "react-datepicker/dist/react-datepicker.css";
import { useSchedule } from "../../../../../hooks/outorga/useSchedule";

registerLocale("pt-BR", ptBR);

const evenOddOptions = [
    { value: "par", label: "Somente Pares" },
    { value: "impar", label: "Somente Ímpares" }
];

const MonthPicker = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        onClick={onClick}
        ref={ref}
        className="grant-schedule__card--header-month-picker-button"
    >
        {helper.toCapitalizeCase(value)} <i className="fa fa-caret-down" />
    </button>
));

const Schedule = (props) => {
    const {
        selectedMonth,
        selectedDays,
        globalEvenOddType,
        onlyEvenOdd,
        evenOddType,
        defaultSchedule,
        controller,
        handleChangeMonth,
        toggleEvenOdd,
        toggleEvenOddInAllMonths,
        changeEvenOddType,
        changeEvenOddTypeInAllMonths,
        toggleAllDays,
        toggleAllDaysInAllMonths,
        handleMouseDown,
        handleMouseEnter,
        handleMouseUp,
        setDefaultSchedule,
        isDayDisabled,
        areAllMonthsEvenOdd,
        areAllDaysSelected,
        areAllDaysInAllMonthsSelected,
        handleSave,
        generateDaysArray,
        isLoading,
        canEdit
    } = useSchedule(props);

    return (
        <div className="grant-schedule">
            {isLoading && (
                <div className="grant-custom-params__loading">
                    <ReactLoading type="spin" width={40} />
                </div>
            )}

            <div className="grant-schedule__card">
                <div>
                    <GenericSwitch
                        checked={areAllDaysInAllMonthsSelected()}
                        onChange={toggleAllDaysInAllMonths}
                        label="Selecionar todos os dias (Em todos os meses)"
                    />
                    <div className="grant-schedule__card--even-odd-config">
                        <GenericSwitch
                            checked={areAllMonthsEvenOdd()}
                            onChange={toggleEvenOddInAllMonths}
                            label="Usar regra de dias pares/ímpares (Em todos os meses)"
                        />
                        <div className="grant-schedule__card--even-odd-config__schedule-select">
                            <Select
                                value={evenOddOptions.find(opt => opt.value === globalEvenOddType)}
                                options={evenOddOptions}
                                placeholder="Regra"
                                onChange={changeEvenOddTypeInAllMonths}
                                disabled={!areAllMonthsEvenOdd()}
                            />
                        </div>
                    </div>
                    <hr/>
                </div>
                <div className="grant-schedule__card--header">
                    <h4>Dias de Trabalho -</h4>

                    <DatePicker
                        selected={selectedMonth}
                        onChange={handleChangeMonth}
                        showMonthYearPicker
                        locale="pt-BR"
                        dateFormat="MMMM"
                        customInput={<MonthPicker />}
                        popperClassName="grant-schedule__card--header-month-picker"
                    />
                </div>

                <GenericSwitch
                    checked={areAllDaysSelected()}
                    onChange={toggleAllDays}
                    label="Selecionar todos os dias"
                    disabled={onlyEvenOdd}
                />

                <div className="grant-schedule__card--even-odd-config">
                    <GenericSwitch
                        checked={onlyEvenOdd}
                        onChange={toggleEvenOdd}
                        label="Usar regra de dias pares/ímpares"
                    />
                    <div className="grant-schedule__card--even-odd-config__schedule-select">
                        <Select
                            value={evenOddOptions.find(opt => opt.value === evenOddType)}
                            options={evenOddOptions}
                            placeholder="Regra"
                            onChange={changeEvenOddType}
                            disabled={!onlyEvenOdd || areAllMonthsEvenOdd()}
                        />
                    </div>
                </div>

                <CalendarGrid
                    days={generateDaysArray()}
                    selectedDays={selectedDays}
                    isDayDisabled={isDayDisabled}
                    controller={controller}
                    onMouseDown={handleMouseDown}
                    onMouseEnter={handleMouseEnter}
                    onMouseUp={handleMouseUp}
                />
            </div>

            <TimeRangeCard
                value={defaultSchedule}
                onChange={(schedule) => setDefaultSchedule(schedule)}
            />

            {canEdit && (
                <div className="grant-schedule__save-btn">
                    <button
                        onClick={handleSave}
                        className="hdv-btn-forms hdv-btn-green"
                    >
                        Salvar
                    </button>
                </div>
            )}
        </div>
    );
};

export default Schedule;